import type { ResolutionDetails } from '@library/types/resolutions/resolutionDetails';

export const transformResolutionDetailsData = ({ data }: ResolutionDetails) => {
  const {
    id: resolutionId,
    attributes: {
      actual_affected_new_wagers_count: actualAffectedWagers,
      actual_refund_amount_cents: actualRefundCents,
      csv_filename: cvsFileName,
      csv_row_count: csvRowCount,
      estimated_affected_new_wagers_count: estimatedAffectedWagers,
      estimated_refund_amount_cents: estimatedRefundCents,
      number_processed: numberOfIdsProcessed,
      processing_started_at: processingStartedAt,
      status
    }
  } = data;

  return {
    actualAffectedWagers,
    actualRefundCents,
    cvsFileName,
    csvRowCount,
    estimatedAffectedWagers,
    estimatedRefundCents,
    numberOfIdsProcessed,
    processingStartedAt,
    resolutionId,
    status
  };
};
